import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Hero.css';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="title-screen-container pixel-border">
          <img 
            src="./assets/title.png"
            alt="Crazy AngryBricks Title Screen"
            className="title-screen"
          />
        </div>
        <h1 className="hero-title glow-text">{t('hero.title')}</h1>
        <p className="hero-subtitle">{t('hero.subtitle')}</p>
        <p className="hero-tagline">{t('hero.tagline')}</p>
        <div className="amstrad-badge">
          <span className="badge-text">FOR AMSTRAD CPC</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;